import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { isDirty } from "redux-form";
import { connect } from "react-redux";
import ConfirmationModal from "./ConfirmationModal";

const ConfirmationModalWrap = (props) => {
    const [state, setState] = useState({ isOpenConfirmModal: false });
    const { isOpenConfirmModal } = state;
    const {
        children,
        isDirtyForm,
        customDirtyProperty,
        closeChildModalRequest,
        closeChildModal,
        closeModal: resetCloseModalRequest,
    } = props;
    const closeModal = () => {
        closeChildModal();
        setState({ ...state, isOpenConfirmModal: false });
    };
    const saveFormChanges = () => {
        resetCloseModalRequest();
        // to submit form get form values and call parent handle submit function with this values
        setState({ ...state, isOpenConfirmModal: false });
    };

    useEffect(() => {
        if (closeChildModalRequest) {
            if (customDirtyProperty || isDirtyForm) {
                setState({ ...state, isOpenConfirmModal: true });
            } else {
                closeChildModal();
            }
        }
    }, [closeChildModalRequest]);

    return (
        <div>
            {children}
            <ConfirmationModal yesHandler={closeModal} noHandler={saveFormChanges} isOpen={isOpenConfirmModal} />
        </div>
    );
};

ConfirmationModalWrap.propTypes = {
    children: PropTypes.any,
    form: PropTypes.string.isRequired,
    isDirtyForm: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired,
    closeChildModal: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
    closeChildModalRequest: PropTypes.bool.isRequired,
    customDirtyProperty: PropTypes.bool,
};

ConfirmationModalWrap.defaultProps = {
    form: "anyForm",
};

export default connect((state, props) => {
    return {
        account: state.account,
        isDirtyForm: props.form ? isDirty(props.form)(state) : false,
    };
})(ConfirmationModalWrap);
